import React from 'react';
export function FAQSection() {
  const faqs = [{
    icon: '📩',
    q: '¿Cómo recibo el sistema y qué incluye?',
    a: 'Apenas completás el pago, recibís automáticamente un correo con acceso al Sistema Maestro de Herrería™ junto con los 8 Regalos Bonus. En menos de 1 minuto podés abrir todo desde tu celular o computadora, sin hablar con nadie y sin esperar aprobaciones. El sistema incluye más de 600 diseños metálicos listos para fabricar, con planos técnicos de medidas exactas, cortes optimizados, armado paso a paso y listas de materiales diseñadas para ahorrar tiempo y dinero. También obtenés acceso al Motor de Presupuestos Profesionales™, el Mapa Maestro del Taller™, y 8 bonus donde aprendés soldadura, herrería artística, tornería, carpintería metálica y proyectos de alto valor comercial.'
  }, {
    icon: '💻',
    q: '¿En qué formato recibo el material?',
    a: 'Todo el contenido es 100% digital. Recibís los planos y guías en formato PDF descargable, organizados dentro de Google Drive. Podés acceder a todo desde cualquier dispositivo, incluso desde el taller, sin instalar software extraño ni tener conocimientos técnicos.'
  }, {
    icon: '🛠️',
    q: '¿Necesito experiencia previa en herrería?',
    a: 'No. Muchos usuarios empezaron desde cero, sin experiencia previa en herrería ni carpintería metálica. El sistema está diseñado para que cualquier persona pueda entender medidas, cortes y armado sin abrumarse. Y si ya tenés experiencia, el Sistema Maestro te permite organizar el taller, fabricar más rápido y cobrar más caro.'
  }, {
    icon: '💰',
    q: '¿Puedo fabricar y vender los proyectos?',
    a: 'Sí. Este sistema fue creado específicamente para fabricar, vender y repetir. No es solo para aprender: es para transformar tu taller improvisado en una fábrica rentable. Los proyectos están diseñados para venderse todo el año, con buen margen y alta demanda.'
  }, {
    icon: '⏳',
    q: '¿Cuánto tiempo tengo acceso al sistema?',
    a: 'El acceso es de por vida. Pagás una sola vez, lo descargás y es tuyo para siempre. Sin suscripciones, sin renovaciones y sin costos ocultos. Podés usarlo hoy, mañana o dentro de cinco años.'
  }, {
    icon: '🧠',
    q: '¿En qué se diferencia de un pack de planos sueltos?',
    a: 'Acá no hay improvisación. No estás comprando planos: estás comprando un sistema completo que te dice qué fabricar, cuándo hacerlo, cómo hacerlo sin errores y cuánto cobrar. Es el sistema operativo del taller, no solo un montón de PDFs sueltos.'
  }, {
    icon: '🏗️',
    q: '¿Qué tipo de proyectos voy a poder fabricar?',
    a: 'Vas a poder fabricar proyectos reales, modernos y de alta demanda. Muebles metálicos con madera, estanterías, escritorios, racks, estructuras funcionales y trabajos de mayor escala. Todos diseñados para fabricarse en 24 horas, venderse y repetirse sin adivinar.'
  }, {
    icon: '🛡️',
    q: '¿Qué pasa si siento que no es para mí?',
    a: 'No corrés ningún riesgo. Estás cubierto por una Garantía de Satisfacción de 7 días. Si el sistema no cumple tus expectativas, escribinos y te devolvemos el 100% de tu dinero. El riesgo es completamente nuestro.'
  }];
  return <section className="py-4 bg-[#050505]" data-id="element-20">
      <div className="max-w-[800px] mx-auto px-4" data-id="element-21">
        <div className="text-center mb-4" data-id="element-22">
          <h2 className="text-xl md:text-2xl font-heading font-bold text-white uppercase" data-id="element-23">
            ❓ FAQ — PREGUNTAS FRECUENTES
          </h2>
        </div>

        <div className="space-y-2" data-id="element-24">
          {faqs.map((faq, index) => <details key={index} className="group bg-slate-900/50 rounded-lg border border-white/10 overflow-hidden cursor-pointer" data-id="element-25">
              <summary className="flex items-center justify-between p-3 font-bold text-sm text-white list-none hover:bg-white/5 transition-colors" data-id="element-26">
                <div className="flex items-center pr-4" data-id="element-27">
                  <span className="text-lg mr-3" data-id="element-28">{faq.icon}</span>
                  {faq.q}
                </div>
                <span className="transition group-open:rotate-180 flex-shrink-0 text-slate-400" data-id="element-29">
                  <svg fill="none" height="20" shapeRendering="geometricPrecision" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" viewBox="0 0 24 24" width="20" data-id="element-30">
                    <path d="M6 9l6 6 6-6" data-id="element-31"></path>
                  </svg>
                </span>
              </summary>
              <div className="px-3 pb-3 text-slate-400 text-sm leading-relaxed border-t border-white/10 pt-3 pl-[3rem]" data-id="element-32">
                {faq.a}
              </div>
            </details>)}
        </div>
      </div>
    </section>;
}